// The pages of a list of videos (a category, a star, a studio, a section, all videos) at their own
// addresses, ?page=N, for search engines: they follow only links, and the feed that scrolls on loads
// further pages from /api/feed, which robots.txt keeps them from. Each page links to the next; pages 2 to
// INDEXED_PAGES may be indexed, deeper ones say noindex, follow (as Pornhub's searches stop at 10).

export const INDEXED_PAGES = 10;
/** Deeper pages are "not found". */
export const LAST_PAGE = 500;

/** The page asked for by ?page=, from 1. */
export function pageOf(v: string | string[] | undefined): number {
  const n = Number(typeof v === "string" ? v : undefined);
  return Number.isInteger(n) && n >= 2 && n <= LAST_PAGE ? n : 1;
}

/** A list's address on page `page` (its other query kept). */
export const pagePath = (path: string, page: number) => (page > 1 ? `${path}${path.includes("?") ? "&" : "?"}page=${page}` : path);

/** Videos to a page of a list (lib/api PAGE_SIZE). */
const PER_PAGE = 30;

/**
 * Whether a list of `count` videos has no page `page`: such an address answers "not found", decided in
 * the page's metadata, before its answer starts streaming (an empty page found later would still say 200).
 */
export const pastLastPage = (page: number, count: number) => page > Math.max(1, Math.ceil(count / PER_PAGE));
